export const WEB_URL = "https://www.assesshub.com/"
// export const WEB_URL = "http://localhost:3000/"
export const SUPPORT_MAIL = "support@pyther.com"
export const answersBaseURL = window.location.host.includes('staging') ? 'https://answers-staging.assesshub.com' : 'https://answers.assesshub.com'
export const resultBaseURL = window.location.host.includes('staging') ? 'https://result-staging.assesshub.com' : 'https://result.assesshub.com'